import {
  CreateResolution,
  ResolutionDetailsHeader,
  ResolutionDetailsSteps
} from '@bo-components/resolutions/resolutionDetails';
import {
  ResolutionDetailsContext,
  ResolutionDetailsStepperContext,
  useResolutionDetails,
  useResolutionDetailsStepper
} from '@bo-hooks/resolutions/resolutionDetails';
import { PageBody } from '@library/components/layout/PageBody';
import { Stepper } from '@library/components/Stepper/Stepper';

export const ResolutionDetails = () => {
  const { resolutionDetailsContext } = useResolutionDetails();

  const { resolutionDetailsStepperContext } = useResolutionDetailsStepper({
    ...resolutionDetailsContext
  });

  const { currentResolutionStep, resolutionSteps } =
    resolutionDetailsStepperContext;

  return (
    <div className="flex size-full flex-col">
      <ResolutionDetailsContext.Provider value={resolutionDetailsContext}>
        <ResolutionDetailsHeader />
        <ResolutionDetailsStepperContext.Provider
          value={resolutionDetailsStepperContext}
        >
          <Stepper steps={resolutionSteps} />
          {currentResolutionStep <= 2 && <CreateResolution />}
          {currentResolutionStep > 2 && (
            <PageBody>
              <ResolutionDetailsSteps
                currentResolutionStep={currentResolutionStep}
              />
            </PageBody>
          )}
        </ResolutionDetailsStepperContext.Provider>
      </ResolutionDetailsContext.Provider>
    </div>
  );
};
